import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useAuth } from 'store/client/authStore'
import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

const SUPER_COMPANY_ID = '6562742a5b252fdddcc5890d'

export function SelectCompany({ name, labelName, changename }) {
  const { values, setFieldValue } = useFormikContext()
  const { user } = useAuth()
  const userCompanyId = user?.companyId ? String(user.companyId) : ''
  const isSuper = !userCompanyId || userCompanyId === SUPER_COMPANY_ID
  const mapCompany = ({ id, _id, name: label }) => ({
    value: String(id ?? _id ?? ''),
    label: label ?? '',
  })

  useEffect(() => {
    if (values?.[name]) return
    if (isSuper) return
    setFieldValue(name, userCompanyId)
  }, [isSuper, name, setFieldValue, userCompanyId, values?.[name]])

  return (
    <AsyncSearchSelect
      label={changename}
      name={name}
      labelName={labelName}
      value={values?.[name]}
      fetchSelected={(id) => firstOption(requests.company.get(id), mapCompany)}
      fetchOptions={async (search) => {
        if (!isSuper) {
          const option = await firstOption(requests.company.get(userCompanyId), mapCompany)
          return option ? [option] : []
        }
        return asOptions(requests.company.list({ search, limit: 20 }), mapCompany)
      }}
    />
  )
}
